// Autogenerated. Do not alter manually. Script: "cafe_factory"
import 'babel-polyfill';

var Logger = require('/Users/dusan/dev/web-scripts/src/logger/logger.js').default;
var KrPanoClient = require('/Users/dusan/dev/web-scripts/src/krpano_client/krpano_client.js').default;
var KrPanoDebugger = require('/Users/dusan/dev/web-scripts/src/krpano_debugger/krpano_debugger.js').default;
var IdleDetector = require('/Users/dusan/dev/web-scripts/src/idle_detector/idle_detector.js').default;
var SceneObserver = require('/Users/dusan/dev/web-scripts/src/scene_observer/scene_observer.js').default;
var VrModeObserver = require('/Users/dusan/dev/web-scripts/src/vr_mode_observer/vr_mode_observer.js').default;
var QueryUserProvider = require('/Users/dusan/dev/web-scripts/src/query_user_provider/query_user_provider.js').default;
var AudienceTrackerApi = require('/Users/dusan/dev/web-scripts/src/audience_tracker_api/audience_tracker_api.js').default;
var AudienceTracker = require('/Users/dusan/dev/web-scripts/src/audience_tracker/audience_tracker.js').default;
var MailNotify = require('/Users/dusan/dev/web-scripts/src/mail_notify/mail_notify.js').default;
var CafeFactory = require('/Users/dusan/dev/web-scripts/src/vendor/cafe_factory/cafe_factory.js').default;
var KrPanoInsights = require('/Users/dusan/dev/web-scripts/src/krpano_insights_renderer/krpano_insights.js').default;

(function (container) {

	container.SPINVIEW_OPTIONS = container.SPINVIEW_OPTIONS || {};

	// Create "Logger"
	if (container.logger) {
		throw new Error('Service "logger" already exists in the container. Check your script tags!');
	}
	container.Logger_options = assign({
	"level": "info"
}, container.SPINVIEW_OPTIONS.Logger);
	container.logger = new Logger(Logger_options, container);

	// Create "KrPanoClient"
	if (container.krPanoClient) {
		throw new Error('Service "krPanoClient" already exists in the container. Check your script tags!');
	}
	container.KrPanoClient_options = assign({}, container.SPINVIEW_OPTIONS.KrPanoClient);
	container.krPanoClient = new KrPanoClient(KrPanoClient_options, container);

	// Create "KrPanoDebugger"
	if (container.krPanoDebugger) {
		throw new Error('Service "krPanoDebugger" already exists in the container. Check your script tags!');
	}
	container.KrPanoDebugger_options = assign({}, container.SPINVIEW_OPTIONS.KrPanoDebugger);
	container.krPanoDebugger = new KrPanoDebugger(KrPanoDebugger_options, container);

	// Create "IdleDetector"
	if (container.idleDetector) {
		throw new Error('Service "idleDetector" already exists in the container. Check your script tags!');
	}
	container.IdleDetector_options = assign({}, container.SPINVIEW_OPTIONS.IdleDetector);
	container.idleDetector = new IdleDetector(IdleDetector_options, container);

	// Create "SceneObserver"
	if (container.sceneObserver) {
		throw new Error('Service "sceneObserver" already exists in the container. Check your script tags!');
	}
	container.SceneObserver_options = assign({}, container.SPINVIEW_OPTIONS.SceneObserver);
	container.sceneObserver = new SceneObserver(SceneObserver_options, container);

	// Create "VrModeObserver"
	if (container.vrModeObserver) {
		throw new Error('Service "vrModeObserver" already exists in the container. Check your script tags!');
	}
	container.VrModeObserver_options = assign({}, container.SPINVIEW_OPTIONS.VrModeObserver);
	container.vrModeObserver = new VrModeObserver(VrModeObserver_options, container);

	// Create "QueryUserProvider"
	if (container.userProvider) {
		throw new Error('Service "userProvider" already exists in the container. Check your script tags!');
	}
	container.QueryUserProvider_options = assign({}, container.SPINVIEW_OPTIONS.QueryUserProvider);
	container.userProvider = new QueryUserProvider(QueryUserProvider_options, container);

	// Create "AudienceTrackerApi"
	if (container.trackerApi) {
		throw new Error('Service "trackerApi" already exists in the container. Check your script tags!');
	}
	container.AudienceTrackerApi_options = assign({}, container.SPINVIEW_OPTIONS.AudienceTrackerApi);
	container.trackerApi = new AudienceTrackerApi(AudienceTrackerApi_options, container);

	// Create "AudienceTracker"
	if (container.audienceTracker) {
		throw new Error('Service "audienceTracker" already exists in the container. Check your script tags!');
	}
	container.AudienceTracker_options = assign({
	"enabled": true,
	"site_key": "cafe_factory"
}, container.SPINVIEW_OPTIONS.AudienceTracker);
	container.audienceTracker = new AudienceTracker(AudienceTracker_options, container);

	// Create "MailNotify"
	if (container.mailNotify) {
		throw new Error('Service "mailNotify" already exists in the container. Check your script tags!');
	}
	container.MailNotify_options = assign({
	"token": "1jTFQaLIEPb3RqLZAy2RkZUxgIpPlIa7E6IbdrALoBVdSSs2As"
}, container.SPINVIEW_OPTIONS.MailNotify);
	container.mailNotify = new MailNotify(MailNotify_options, container);

	// Create "CafeFactory"
	if (container.cafeFactory) {
		throw new Error('Service "cafeFactory" already exists in the container. Check your script tags!');
	}
	container.CafeFactory_options = assign({}, container.SPINVIEW_OPTIONS.CafeFactory);
	container.cafeFactory = new CafeFactory(CafeFactory_options, container);

	// Create "KrPanoInsights"
	if (container.krPanoInsights) {
		throw new Error('Service "krPanoInsights" already exists in the container. Check your script tags!');
	}
	container.KrPanoInsights_options = assign({}, container.SPINVIEW_OPTIONS.KrPanoInsights);
	container.krPanoInsights = new KrPanoInsights(KrPanoInsights_options, container);

	initialize([
		container.krPanoClient.init,
		container.krPanoDebugger.init,
		container.idleDetector.init,
		container.sceneObserver.init,
		container.vrModeObserver.init,
		container.audienceTracker.init,
		container.cafeFactory.init,
		container.krPanoInsights.init,
	]);

	function assign(source, target) {
		if (!target) {
			return source;
		}

		for (var key in target) {
			if (target.hasOwnProperty && target.hasOwnProperty(key) && target[key] !== undefined) {
				source[key] = target[key];
			}
		}
		return source;
	}


	function initialize(fns) {
		var index = 0;
		next();

		function next() {
			if (index >= fns.length) {
				return;
			}
			if (fns[index].length > 0) {
				fns[index](callback);
			} else {
				fns[index]();
				callback();
			}
		}

		function callback(err) {
			if (err) {
				if (!err._logged) {
					console.error(err);
				}
			}
			index++;
			next();
		}
	}

})(window);
